import { TextSize } from '@rsos/base-components/Text';
import { Text } from '@rsos/components/capstone/base';
import exportToGlobalNamespace from '@rsos/utils/exportToGlobalNamespace';

// NOTE REACT_APP_FE_VERSION is set in .env, value which is mapped
// from $FE_VERSION at build-time.
const envVersion = process.env.REACT_APP_FE_VERSION || 'default';

exportToGlobalNamespace('env', process.env);
exportToGlobalNamespace('version', envVersion);

/**
 * Strips the 'mw-' prefix from the given version string.
 * @param {String} version - The version to be cleaned
 */
export const cleanupVersion = (version = '') => {
  if (!version) {
    return '';
  }

  if (typeof version !== 'string') {
    return version;
  }
  return version
    .toLowerCase()
    .replace('mw-', '')
    .replace('-dev', '')
    .replace('develop-', '');
};

const VersionNumber = ({
  version = envVersion,
  color = 'secondaryText',
  size = 'small' as TextSize,
}) => {
  return (
    <Text size={size} color={color} ellipsis>
      {`v${cleanupVersion(version)}`}
    </Text>
  );
};

export default VersionNumber;
